import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormControl, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment';
import { Location } from '@angular/common';
import { CadastroUsuarioBackofficeService } from './cadastro-usuario-backoffice.service';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { DateUtilService } from '../../../shared/services/date-util.service';

@Component({
  selector: 'ngx-cadastro-usuario-backoffice',
  templateUrl: './cadastro-usuario-backoffice.component.html',
  styleUrls: ['./cadastro-usuario-backoffice.component.scss']
})
export class CadastroUsuarioBackofficeComponent implements OnInit {


  public formCadastroUserBack = null;
  public tipo = null;
  public senha = null;
  public confirmarSenha = null;
  public checked = null;
  public grupoUser = [];

  public yesterday = new Date((new Date()).valueOf() - 1000*60*60*24);

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    disableUntil: { year: this.yesterday.getFullYear(), month: this.yesterday.getMonth() + 1, day: this.yesterday.getDate() },
  };

  constructor(
    private formBuilder: FormBuilder,
    private service: CadastroUsuarioBackofficeService,
    private notificationService: NotificationsService,
    private router: Router,
    private location: Location,
    private spinnerService: NgxSpinnerService,
    private dateUtilService: DateUtilService,

  ) {

    this.grupoUser = [];

  }

  ngOnInit() {

    this.formCadastroUserBack = this.formBuilder.group({
      nome: [null],
      login: [null],
      email: [null],
      senha: [null],
      confirmaSenha: [null],
      dataExpiracao: [null],
      admin: [null],
      callCenter: [null],
      posVenda: [null],
      operacao: [null],


    });

  }

  validarSenhas = (data): ValidatorFn => {

    this.confirmarSenha = data.confirmaSenha;

    if (this.formCadastroUserBack) {

      this.senha = this.formCadastroUserBack.get('senha').value

    }

    if (this.senha != this.confirmarSenha) {

      this.notificationService.warn('Senha não confere');

    }

    return null;
  }

  acessar() {

    this.formCadastroUserBack.getRawValue()

  }

  gotoCadastrar(data) {

    if (data.dataExpiracao != null) {

      this.dateUtilService.datepickerTransformDate(data.dataExpiracao, 'YYYY-MM-DD')
      let dataExpiracao = this.getDateTimestamp(data.dataExpiracao);
      data.dataExpiracao = dataExpiracao;

    }

    let register = {

      confirmaSenha: data.confirmaSenha,
      dataExpiracao: data.dataExpiracao,
      email: data.email,
      gruposPermissoes: this.grupoUser,
      login: data.login,
      nome: data.nome,
      senha: data.senha,
      status: 'ATIVO',

    }

    this.spinnerService.show();

    this.service.gravarUserbackoffice(
      register,
      (response) => {
        this.spinnerService.hide();
        this.notificationService.success('Usuário Backoffice Cadastrado Com Sucesso');
        this.limparForms();
      }, (error) => {
        this.spinnerService.hide();
        this.notificationService.error(error.message);
      });


  }

  getDateTimestamp(data) {

    let dataReturn = null;
    if ('jsdate' in data) {
      dataReturn = new Date(data.jsdate)
      dataReturn = moment(dataReturn).format('YYYY-MM-DD');
    } else {
      dataReturn = new Date(data.date['year'], data.date['month'] - 1, data.date['day']).getTime();
      dataReturn = moment(dataReturn).format('YYYY-MM-DD');
    }

    return dataReturn;
  }

  limpaCampos() {

    this.formCadastroUserBack.controls['confirmaSenha'].setValue(null);

  }

  togglePaymentTypesFields(data) {

    if (data.checked == true) {
      this.grupoUser.push(data.value);
    } else {
      this.grupoUser = this.grupoUser.filter(grupo => grupo != data.value)
    }

  }

  previousPage() {

    this.location.back();
    this.limparForms();

  }

  gotoVoltar() {

    this.location.back();
    this.limparForms();

  }

  limparForms() {

    this.formCadastroUserBack = this.formBuilder.group({
      nome: [null],
      login: [null],
      email: [null],
      senha: [null],
      confirmaSenha: [null],
      dataExpiracao: [null],
      admin: [null],
      callCenter: [null],
      posVenda: [null],
      operacao: [null],


    });


  }

}
